module.exports = __webpack_public_path__ + "img/39.edfe69e1.gif";